import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Field from 'component/utils/Field'
import RegionBranchMultipleSelectNew from 'component/branch/RegionBranchMultipleSelectNew'
import { CustomMenuList as MenuList } from 'component/reactSelect/CustomMenuList'
import { CustomMultiValue as MultiValueContainer } from 'component/reactSelect/CustomMultiValue'
import Form from 'component/paramsSupply/Form'
import { formatMoney } from 'utils/masks'
import { hasEmptyProperties, arraysEqual } from 'utils/validations'
import moment from 'moment'

const FirstParameterAdjust = ({ field, label, rightLabel, translate, setValueToField }) => (
  <tr className={'mobiItem'}>
    <td>{translate(label)}</td>
    <td>
      <input
        value={(field.input.name === 'amountCountAbovePercentageRlDecimal' && field.input.value.replace(/\D/, '')) ? formatMoney(field.input.value.replace(/\D/, '')) : field.input.value}
        onChange={(e) => {
          setValueToField(field.input.name, e.target.value.replace(/\D/g, ''))
        }}
        placeholder={field.input.name === 'amountCountAbovePercentageRlDecimal' ? '0,00' : '0'}
        className='form-control'
        type='input'
        mask
      />
      <span className='margin-left-extra-small'>{translate(rightLabel)}</span>
    </td>
  </tr>
)

FirstParameterAdjust.propTypes = {
  field: PropTypes.object,
  label: PropTypes.string,
  rightLabel: PropTypes.string,
  translate: PropTypes.func,
  setValueToField: PropTypes.func,
}

class ParamsSupplyForm extends Component {
  state = {
    previousValues: {}
  }

  UNSAFE_componentWillReceiveProps({ savedSupplyParam: nextGama }) {
    const {
      savedSupplyParam
    } = this.props

    if (savedSupplyParam !== nextGama && !hasEmptyProperties(nextGama)) {
      this.fillForms(nextGama)
    }
  }

  fillForms = ({ notSelectSameAddressWithinDays, amountCountAbovePercentage, amountCountAbovePercentageRl }) => {
    this.setValueToField('notSelectSameAddressWithinDays', notSelectSameAddressWithinDays.toString())
    this.setValueToField('amountCountAbovePercentage', amountCountAbovePercentage.toString())
    this.setValueToField('amountCountAbovePercentageRl', amountCountAbovePercentageRl.toString())

    this.setState({
      previousValues: {
        ...this.state.previousValues,
        notSelectSameAddressWithinDays: notSelectSameAddressWithinDays.toString(),
        amountCountAbovePercentage: amountCountAbovePercentage.toString(),
        amountCountAbovePercentageRl: amountCountAbovePercentageRl.toString()
      }
    })
  }

  setValueToField = (field, value) => {
    const { setValueToField } = this.props
    setValueToField(field, value)
    this.setState({ somethingTouched: true })
  }

  async clearForm(cleanStore) {
    const { setValueToField } = this.props

    setValueToField('notSelectSameAddressWithinDays', '')
    setValueToField('amountCountAbovePercentage', '')
    setValueToField('amountCountAbovePercentageRl', '')
    if (cleanStore) setValueToField('listRegionsAndBranchs', '')
  }

  handleSubmit = () => {
    
    const { values, onSubmit,  savedSupplyParam } = this.props
    const idSupply = savedSupplyParam ? savedSupplyParam.idSupply : null
    const previousValues = {
      ...values,
    }

    const selectedBranches = values.listRegionsAndBranchs || []

    const gamaRegionsBranchsParams = []
    const branchs = []
    for (const option of selectedBranches) {

      if (option.idBranches) {
        branchs.push(...option.idBranches)
      } else if(option.value){
        branchs.push(option.value)
      }

      if (option.value !== 'all') {
        const gamaRegionsBranchsParam = {
          idGama: null,
          branchRegion: option.value,
          dsBranchRegion: option.label,
          inRegion: option.isBranch === undefined ? 1 : 0,
        }

        gamaRegionsBranchsParams.push(gamaRegionsBranchsParam)
      }
    }

    onSubmit({
      ...previousValues,
      cdBranchs:branchs,
      idSupply: branchs.length <= 1 ? idSupply : null,
      wareHouseId: 'C010',
      dsYear: moment().year(),
      gamaRegionsBranchsParams,
    }, () => {
     
      this.setState({ previousValues })
    })
  }

  branchChange = async (selectedOption, input) => {
    const {
      auth: { user },
      fetchSections,
      setValueToField
    } = this.props

    input.value = selectedOption
    const event = { target: input }
    input.onChange(event)
    setValueToField('listRegionsAndBranchs', selectedOption)
    this.setState({ previousValues: { listRegionsAndBranchs: selectedOption } })

    if (
      selectedOption.length === 1 &&
      selectedOption[0].value !== 'all' &&
      selectedOption[0].isBranch !== undefined
    ) {
      fetchSections(user.dsToken, {
        gamaRegionsBranchsParams: [
          {
            idGama: null,
            branchRegion: selectedOption[0].value,
            inRegion: 0,
          },
        ],
        wareHouseId: 'C010'
      })
    } else this.clearForm(false)
  }

  hasRequiredEmpty() {
    const { values } = this.props
    let has = false
    const fields = ['notSelectSameAddressWithinDays', 'amountCountAbovePercentage', 'amountCountAbovePercentageRl']

    fields.forEach(field => {
      if (values[field] === '') has = true
    })

    if (!values.listRegionsAndBranchs || values.listRegionsAndBranchs.length === 0) has = true

    return has
  }

  sameValues() {
    const { values } = this.props
    const { previousValues } = this.state

    let sameValues = true

    if (hasEmptyProperties(previousValues)) {
      sameValues = false
    } else {
      const fields = ['notSelectSameAddressWithinDays', 'amountCountAbovePercentage']

      fields.forEach(field => {
        if (parseFloat(values[field]) !== parseFloat(previousValues[field])) sameValues = false
      })

      if (previousValues.amountCountAbovePercentageRl  !== values.amountCountAbovePercentageRl) sameValues = false

      if (!arraysEqual(values.listRegionsAndBranchs, previousValues.listRegionsAndBranchs)) sameValues = false
    }

    return sameValues
  }

  render() {
    const {
      translate,
      fields
    } = this.props

    return (
      <Col md={10} mdOffset={1}>
        <form className='GamaForm-new'>
          <fieldset>
            <Row>
              <div className='margin-bottom margin-left-small margin-right-small'>
                <Field {...fields.listRegionsAndBranchs}>
                  <h4 className='no-margin'>
                    <b>{translate('scheduleBlock.branchs')}</b>
                  </h4>
                  <RegionBranchMultipleSelectNew
                    required
                    id='listRegionsAndBranchs'
                    paramsSupply
                    {...fields.listRegionsAndBranchs.input}
                    placeholder={translate('select.one.store')}
                    components={{ MenuList, MultiValueContainer }}
                    translate={translate}
                    onChange={(event) =>
                      this.branchChange(
                        event.target.value,
                        fields.listRegionsAndBranchs.input
                      )
                    }
                    excludeInactive={true}
                  />
                </Field>
              </div>
            </Row>
            <Row>
              <Col xs={12}>
                <h4 className='no-margin'>
                  <b>{translate('mobile.ponctual.title')}</b>
                </h4>
                <div className={'mobiCard'}>
                  <table cellPadding='0' cellSpacing='0' className='new-table'>
                    <thead>
                      <tr>
                        <th scope={'col'} colSpan='1'>
                          {translate('parameter')}
                        </th>
                        <th colSpan='4'>
                          {translate('newPriceBannerFragment.values')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <FirstParameterAdjust
                        label='irc.gama.labelJustificationDifference'
                        rightLabel='irc.gama.labelJustificationDifferencePercentage'
                        field={fields.amountCountAbovePercentage}
                        setValueToField={this.setValueToField}
                        translate={translate}
                      />
                      <FirstParameterAdjust
                        label='irc.gama.justificationPerRealDifference'
                        rightLabel='irc.gama.labeljustificationPerRealDifference'
                        field={fields.amountCountAbovePercentageRl}
                        setValueToField={this.setValueToField}
                        translate={translate}
                      />
                      <FirstParameterAdjust
                        label='params.supply.address.do.not.repeat'
                        rightLabel='irc.gama.labelDays'
                        field={fields.notSelectSameAddressWithinDays}
                        setValueToField={this.setValueToField}
                        translate={translate}
                      />
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
            <Row className='margin-top-double margin-bottom'>
              <Col md={2} mdOffset={8}>
                <button
                  role='button'
                  type='button'
                  className='btn btn-danger-outline button-full'
                  onClick={() => this.clearForm(true)}
                  disabled={(!fields.listRegionsAndBranchs || fields.listRegionsAndBranchs.input.value.length < 1)}
                >
                  {translate('button.clean')}
                </button>
              </Col>
              <Col md={2}>
                <button
                  role='button'
                  type='button'
                  className='btn btn-primary button-full'
                  disabled={this.hasRequiredEmpty() || this.sameValues()}
                  onClick={this.handleSubmit}
                >
                  {translate('save_button_label')}
                </button>
              </Col>
            </Row>
          </fieldset>
        </form>
      </Col>
    )
  }
}

ParamsSupplyForm.propTypes = {
  fields: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.object,
  fetchSections: PropTypes.func.isRequired,
  savedSupplyParam: PropTypes.object,
}

const fields = [
  'notSelectSameAddressWithinDays',
  'amountCountAbovePercentage',
  'amountCountAbovePercentageRl',
  'listRegionsAndBranchs',
]

export default Form({ fields })(ParamsSupplyForm)

export { ParamsSupplyForm }
